"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization converter of {@link SelloutIdentificationDetailDTO}.
 *
 * @author Adam Drda
 */


var SelloutIdentificationDetailDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutIdentificationDetailDTOConverter, _DataObjectConverter_);

  function SelloutIdentificationDetailDTOConverter() {
    _classCallCheck(this, SelloutIdentificationDetailDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationDetailDTOConverter).apply(this, arguments));
  }

  return SelloutIdentificationDetailDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutIdentificationDetailDTOConverter = SelloutIdentificationDetailDTOConverter;